if (!customElements.get('variant-option-reveal')) {
  customElements.define(
    'variant-option-reveal',
    class VariantOptionReveal extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button[aria-controls]');
        if (!this.button) return;
        this.panel = document.getElementById(this.button.getAttribute('aria-controls'));
        if (!this.panel) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      onClick() {
        const open = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', String(!open));
        if (open) {
          this.panel.setAttribute('hidden', '');
        } else {
          this.panel.removeAttribute('hidden');
        }
      }
    }
  );
}
